import * as Yup from "yup";

const NakshtraSchema = Yup.object().shape({
  start_time: Yup.string().required("Start Date is required"),
  end_time: Yup.string().required("End Date is required"),
  name: Yup.string().required("Lagan is required"),
});

export default NakshtraSchema;
